'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateUnseenThreadsCountExcludeCurrent = undefined;

var _reselect = require('reselect');

var _threadGetters = require('conversations-schema/thread/operators/threadGetters');

var _getThreadList = require('./getThreadList');

var _getSelectedThreadId = require('../../selected-thread/selectors/getSelectedThreadId');

var calculateUnseenThreadsCountExcludeCurrent = exports.calculateUnseenThreadsCountExcludeCurrent = (0, _reselect.createSelector)([_getThreadList.getThreadList, _getSelectedThreadId.getSelectedThreadId], function (threads, selectedThreadId) {
  if (!threads) {
    return 0;
  }
  return threads.reduce(function (unseenCount, thread) {
    if ((0, _threadGetters.getThreadId)(thread) !== selectedThreadId) {
      return unseenCount + (thread.unseenCount ? 1 : 0);
    }
    return unseenCount;
  }, 0);
});